import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import { CookieConsentProvider } from "@/context/CookieConsentContext";
import MarketingLayout from "@/components/layout/MarketingLayout";
import AdminLayout from "@/components/layout/AdminLayout";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

import Home from "@/pages/Home";
import Team from "@/pages/Team";
import Events from "@/pages/Events";
import Partners from "@/pages/Partners";
import Netwerk from "@/pages/Netwerk";
import Privacybeleid from "@/pages/Privacybeleid";
import LidWorden from "@/pages/LidWorden";
import Contact from "@/pages/Contact";

import Login from "@/pages/admin/Login";
import Overview from "@/pages/admin/Overview";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminPartners from "@/pages/admin/AdminPartners";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminPrivacy from "@/pages/admin/AdminPrivacy";
import Submissions from "@/pages/admin/Submissions";

function App() {
  return (
    <AuthProvider>
      <SiteConfigProvider>
      <BrowserRouter>
        <CookieConsentProvider>
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/team" element={<Team />} />
            <Route path="/events" element={<Events />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/netwerk" element={<Netwerk />} />
            <Route path="/privacybeleid" element={<Privacybeleid />} />
            <Route path="/lid-worden" element={<LidWorden />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Overview />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="partners" element={<AdminPartners />} />
            <Route path="galerij" element={<AdminGallery />} />
            <Route path="instellingen" element={<AdminSettings />} />
            <Route path="privacy" element={<AdminPrivacy />} />
            <Route path="inzendingen" element={<Submissions />} />
          </Route>
        </Routes>
        </CookieConsentProvider>
      </BrowserRouter>
      </SiteConfigProvider>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
